<template>
  <div class="flex">
    <div class="search-full-container w-full h-full absolute left-0 top-0" :class="{'flex': showFullSearch}" v-if="showFullSearch">

      <input
        ref="navbarSearch"
        search_key="title"
        background-overlay
        class="w-full input-search"
        icon="SearchIcon"
        placeholder="ادخل الكود للبحث عن طلبك"
        v-model="searchQuery"
        @keyup.esc="showFullSearch = false"
        @keyup.enter="searchCode()"
        @blur="showFullSearch = false, searchQuery = '', error = false" />

      <div class="absolute right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false" />
      </div>
      <p class="error-code" v-if="error">{{ errorMsg }}</p>
    </div>

    <div class="search-full-container w-full h-full absolute left-0 top-0" :class="{'flex': showFullLabelSearch}" v-if="showFullLabelSearch">

      <input
        ref="navbarLabelSearch"
        class="w-full input-search"
        placeholder="ادخل كود الملصق الذكي للبحث عن طلبك"
        v-model="labelSearchQuery"
        @keyup.esc="showFullLabelSearch = false"
        @keyup.enter="searchByLabel()"
        @blur="showFullLabelSearch = false, labelSearchQuery = '', labelError = false" />

      <div class="absolute right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullLabelSearch = false" />
      </div>
      <p class="error-code" v-if="labelError">{{ labelErrorMsg }}</p>
    </div>

    <vx-tooltip text="البحث" position="bottom" delay=".2s">
      <feather-icon svgClasses="'h-6 w-6" class="p-2 cursor-pointer" icon="SearchIcon" @click="showSearch(), googleEventTrack('الضغط على ايقون البحث العادية', 'navbar', 'search_icon_in_navbar')" />
    </vx-tooltip>

    <vx-tooltip text="البحث بكود الملصق الذكي" position="bottom" delay=".2s">
      <span class="p-2 cursor-pointer qr-search-icon" @click="showLabelSearch()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
          <line x1="14" y1="14" x2="14" y2="17"></line>
          <line x1="14" y1="20" x2="14" y2="20.01"></line>
          <line x1="17" y1="14" x2="20" y2="14"></line>
          <line x1="20" y1="17" x2="17" y2="17"></line>
          <line x1="17" y1="20" x2="20" y2="20"></line>
        </svg>
      </span>
    </vx-tooltip>
  </div>
</template>

<script>
import gTag from "@/mixins/gtag.js"
import { mapActions } from "vuex"

export default {
  mixins: [gTag],
  components: {
  },
  data () {
    return {
      showFullSearch: false,
      searchQuery: '',
      error: false,
      errorMsg: '',
      showFullLabelSearch: false,
      labelSearchQuery: '',
      labelError: false,
      labelErrorMsg: '',
    }
  },
  computed: {

  },
  methods: {
    ...mapActions("dataList", ["searchByLabelCode", "orderDetails"]),
    showSearch(){
      this.showFullSearch = true
      setTimeout(()=>{ this.$refs.navbarSearch.focus(); }, 10);
    },
    async searchCode() {
      if(this.searchQuery == '') {
        this.error = true
        this.errorMsg = 'برجاء ادخال كود الطلب اولاً'
        return
      }
      await this.orderDetails(this.searchQuery)
      if(this.$store.state.dataList.successApi === 1) {
        this.error = false
        this.$router.replace({ path: `/OrderDetails/${this.searchQuery}`, query: { from: 'search' } }).catch(() => {})
      } else {
        this.error = true
        this.errorMsg = this.$store.state.dataList.err_msg || 'رقم الكود خاطئ, برجاء المحاولة مرة اخري'
      }
    },
    showLabelSearch(){
      this.showFullLabelSearch = true
      setTimeout(()=>{ this.$refs.navbarLabelSearch.focus(); }, 10);
    },
    async searchByLabel() {
      if(this.labelSearchQuery == '') {
        this.labelError = true
        this.labelErrorMsg = 'برجاء ادخال كود الملصق اولاً'
        return
      }
      const data = await this.searchByLabelCode(this.labelSearchQuery)
      if(data.success == 1 && data.feed && data.feed.code) {
        this.labelError = false
        this.$router.replace({ path: `/OrderDetails/${data.feed.code}`, query: { from: 'search' } }).catch(() => {})
      } else {
        this.labelError = true
        this.labelErrorMsg = data.error_msg || 'كود الملصق غير صحيح'
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.input-search{
  border: none;
  padding: 0 40px;
  color: #6e6b7b;
  font-family: 'cairo';
  font-size: 16px;
  letter-spacing: 1px;
}
.input-search::placeholder{
  font-family: 'cairo';
  font-size: 16px;
  letter-spacing: 1px;
}
.error-code {
  position: absolute;
  top: 42px;
  font-size: 12px;
  color: red;
  left: 39px;
  background: #ff000017;
  padding: 0px 10px;
  border-radius: 4px;
}
.qr-search-icon {
  display: inline-flex;
  align-items: center;
  color: inherit;
}
</style>